
(function( ){

//------------------------------------------------------------------------------------------------------------------------------

	EasySwitch = function( )
	{
		var _this = this, i;


		var TARGET = "target";
		var SPACE = " ";

		var html = document.documentElement;
		var body = document.body;
		var bodyStyle = document.createElement("style");
		bodyStyle.innerHTML = "body{overflow:hidden;}";


		var _onButton = function( evt )
		{
			var button = evt.currentTarget ;
			var switchTarget = EasySwitch.instance[button.componentID].target ;

			EasySwitch.apply(button.componentID, button.appnedClassName, button.isScrollLock, button.applyStyle);

			// switchTarget.className = switchTarget.defaultClassName + SPACE + button.appnedClassName ;


			// //bodyのスクロール禁止
			// if(button.isScrollLock){
			// 	body.appendChild(bodyStyle) ;
			// }else {
			// 	if( bodyStyle.parentNode ){
			// 		bodyStyle.parentNode.removeChild(bodyStyle);
			// 	}
			// }


			// //その他に固有のスタイルを当てたい場合の処理
			// var style = EasySwitch.instance[button.componentID].style ;
			// if(button.applyStyle){
			// 	style.innerHTML = button.applyStyle ;
			// 	body.appendChild(style) ;
			// }else {
			// 	if( style.parentNode ){
			// 		style.parentNode.removeChild(style);
			// 	}
			// }
		}


		var jsTarget = document.getElementsByClassName( "js-easySwitch" );

		for(i = 0; i < jsTarget.length; i++){
			var temp = jsTarget[i] ;
			var data = temp.getAttribute( "data-easySwitch" ).split(",");

			if(!EasySwitch.instance[data[0]]) {
				EasySwitch.instance[data[0]] = {
					target: null,
					button: [],
					style: document.createElement("style")
				}
			}

			temp.componentID = data[0] ;

			switch(data[1]){
				case TARGET :
					EasySwitch.instance[data[0]].target = temp ;
					temp.defaultClassName = temp.className ;
					break ;

				default :
					EasySwitch.instance[data[0]].button.push( temp );
					temp.appnedClassName = data[1];
					temp.isScrollLock = temp.getAttribute("data-easySwitch-isScrollLock")!=undefined;
					temp.applyStyle = temp.getAttribute("data-easySwitch-style");
					temp.addEventListener("click" , _onButton);
					break ;
			}
		}


		EasySwitch.apply = function(componentID, applyClassName, isScrollLock, applyStyle){
			var switchTarget = EasySwitch.instance[componentID].target;
			switchTarget.className = switchTarget.defaultClassName + SPACE + applyClassName ;


			//bodyのスクロール禁止
			if(isScrollLock){
				body.appendChild(bodyStyle) ;
			}else {
				if( bodyStyle.parentNode ){
					bodyStyle.parentNode.removeChild(bodyStyle);
				}
			}

			//その他に固有のスタイルを当てたい場合の処理
			var style = EasySwitch.instance[componentID].style ;
			if(applyStyle){
				style.innerHTML = applyStyle ;
				body.appendChild(style) ;
			}else {
				if( style.parentNode ){
					style.parentNode.removeChild(style);
				}
			}
		}

	}
	EasySwitch.instance = {} ;

//------------------------------------------------------------------------------------------------------------------------------

	// DOMの準備が完了したら、呼ぶ
	document.readyState === "complete"
		? setTimeout( function(){ new EasySwitch() ; } , 1 )
		: document.addEventListener( "DOMContentLoaded", function(){ new EasySwitch() ; } ) ;

} )( ) ;
